import { useEffect } from "react";
import { useThree } from "@react-three/fiber";

const Room = ({ selectMesh, selectEdge, meshes }) => {
    // console.log("ROOM");

    const { invalidate } = useThree();
    useEffect(() => {
        setTimeout(invalidate, 10);
        // invalidate();
    }, [meshes, invalidate]);

    return (
        <group dispose={null}>
            <group rotation={[Math.PI / 2, 0, 0]} scale={0.01} position={[0, -1.5, 2.5]}>
                {meshes.map((mesh, index) => (
                    <group key={mesh.uuid}>
                        <mesh
                            castShadow={mesh.castShadow}
                            receiveShadow={mesh.receiveShadow}
                            // rotation={mesh.rotation}
                            // position={mesh.position}
                            geometry={mesh.geometry}
                            material={mesh.material}
                            onClick={(e) => {
                                e.stopPropagation();
                                selectMesh(index);
                            }}
                        />
                        {mesh.userData.tile && (
                            <mesh
                                receiveShadow
                                geometry={mesh.geometry}
                                material={mesh.userData.tile}
                            />
                        )}

                        {mesh.userData.edges?.length > 0 &&
                            mesh.userData.edges.map((edge) => {
                                return (
                                    <mesh
                                        key={edge.uuid}
                                        scale={edge.size}
                                        rotation={edge.turning}
                                        position={edge.location}
                                        geometry={edge.geometry}
                                        material={edge.material}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            selectEdge(edge);
                                        }}
                                    />
                                );
                            })}

                        {/* {mesh.userData.carpet && (
                            <mesh
                                position={[0, -490 / 2, 0]}
                                // rotation={[Math.PI / 2, 0, 0]}
                                geometry={mesh.userData.carpet.geometry}
                                material={mesh.userData.carpet.material}
                            />
                        )} */}

                        {mesh.userData.groutTop && (
                            <mesh
                                rotation={mesh.userData.groutTop.rotation}
                                position={mesh.userData.groutTop.position}
                                geometry={mesh.userData.groutTop.geometry}
                                material={mesh.userData.groutTop.material}
                            />
                        )}

                        {mesh.userData.groutBottom && (
                            <mesh
                                rotation={mesh.userData.groutBottom.rotation}
                                position={mesh.userData.groutBottom.position}
                                geometry={mesh.userData.groutBottom.geometry}
                                material={mesh.userData.groutBottom.material}
                            />
                        )}

                        {mesh.userData.tileTop && (
                            <mesh
                                rotation={mesh.userData.tileTop.rotation}
                                position={mesh.userData.tileTop.position}
                                geometry={mesh.userData.tileTop.geometry}
                                material={mesh.userData.tileTop.material}
                            />
                        )}

                        {mesh.userData.tileBottom && (
                            <mesh
                                rotation={mesh.userData.tileBottom.rotation}
                                position={mesh.userData.tileBottom.position}
                                geometry={mesh.userData.tileBottom.geometry}
                                material={mesh.userData.tileBottom.material}
                            />
                        )}
                    </group>
                ))}
            </group>
        </group>
    );
};

export default Room;
